import { render, staticRenderFns } from "./previewSocial.vue?vue&type=template&id=4d2847ea&scoped=true&"
import script from "./previewSocial.vue?vue&type=script&lang=js&"
export * from "./previewSocial.vue?vue&type=script&lang=js&"
import style0 from "./previewSocial.vue?vue&type=style&index=0&id=4d2847ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2847ea",
  null
  
)

export default component.exports